import { CheckoutOrderType as t } from "@ancon/wildcat-types";
function r(o) {
  return (o == null ? void 0 : o.orderType) === t.GroupPreOrder;
}
export {
  r as default
};
